import { isNumber } from 'lodash';
import { computed } from 'mobx';

import { changeDistanceStore } from '../../stores';

export const changeDistancePaidPrice = computed((): number | null => {
  const paidPrice = changeDistanceStore.details?.paid_price;

  return isNumber(paidPrice) && paidPrice > 0 ? paidPrice : null;
});

export const changeDistanceFee = computed((): number => {
  const changeFee = changeDistanceStore.details?.change_fee;

  return isNumber(changeFee) && changeFee > 0 ? changeFee : 0;
});
